/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_NextInputs */

const vi_grower_area_camera_next = /** @type {(inputs: Grower_Area_Camera_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera sau`)
};

/**

* @param {Grower_Area_Camera_NextInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_next = /** @type {((inputs?: Grower_Area_Camera_NextInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_NextInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_next(inputs)
});